
/**
 * This is a placeholder service until we come to a decision on how to handle lens styles updates.
 */
import { LensStyle } from './data/lensstyle';
import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class LensStyleApiService implements OnInit {

  private _url = 'assets/lens-style-data.json';


  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  constructor(private http: HttpClient) { }

  getLensStyle(): Observable<LensStyle[]> {

    console.log('start getLensStyle()');
    return this.http.get<LensStyle[]>(this._url);
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/lens-style.api.service.ts